<script>
  import { onMount } from "svelte";
  import UserActions from "./UserActions.svelte";
  import { createEventDispatcher } from "svelte";
  
  const dispatch = createEventDispatcher();

  export let utility;
  let txtSearch;
  // Show mobile icon and display menu
  let showMobileMenu = false;

  // Mobile menu click event handler
  const handleMobileIconClick = () => (showMobileMenu = !showMobileMenu);

  // Media match query handler
  const mediaQueryHandler = (e) => {
    // Reset mobile state
    if (!e.matches) {
      showMobileMenu = false;
    }
    // TODO: If small media: Show mobile menu & don't show utility name (title)
  };

  // Attach media query listener on mount hook
  onMount(() => {
      const mediaListener = window.matchMedia("(max-width: 767px)");
      mediaListener.addListener(mediaQueryHandler);
      txtSearch.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          dispatch("search", { text: txtSearch.value });
        }
      });
  });

</script>

<nav>
    <div class="inner">
        <img class="logo" src="images/iconWPN2-83p5@2x.png" alt="WPN2 logo" />
        <input
            id="txt-search"
            type="search"
            bind:this={txtSearch}
            placeholder="Search map"
        />
        <a href={"#"} class="search-button" aria-label="Search" on:click={() => dispatch("search", { text: txtSearch.value })}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="24" y1="24" x2="16.5" y2="16.5"></line>
            </svg>
        </a>        
        {#if utility}
            {#if utility['short_name'] != undefined}
                <h1 class="utility-title">{utility['short_name']}</h1>
            {:else}
                <h1 class="utility-title">{utility['name'] ?? ""}</h1>
            {/if}
        {/if}
        <div class="menu-buttons">
            <ul class="navbar-list">
                <li>
                    <a class="navbar-item" href={"#"} on:click={() => dispatch("alfx", {cat: 'nhm'})}>ALFX</a>
                </li>
                <li>
                    <a class="navbar-item" href={"#"} on:click={() => dispatch("assets", {cat: 'assets'})}>Assets</a>
                </li>
                <li>
                    <UserActions on:sign-out on:support on:view on:analysis/>
                </li>
            </ul>
        </div>
    </div>
</nav>

<style>
  /* @import url("https://stackpath.bootstrapcdn.com/bootstrap/4.5.0/css/bootstrap.min.css"); */
    nav {
        background-color: rgba(0, 0, 0, 0.6);
        height: 49px;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
    .inner {
        display: flex;
        height: 100%;
        margin: auto;
    }
    .logo {
        margin: auto 4px;
        width: 32px;
        border-radius: 8px;
    }
    .utility-title {
        margin: auto;
        padding-left: 16px;
        color: whitesmoke;
        font-weight: 150;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .search-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 48px;
        border-radius: 50%;
        color: white;
        text-decoration: none;
        cursor: pointer;
}
    .search-button svg {
        width: 24px;
        height: 24px;
        fill: none;
        stroke: white;
    }
    #txt-search {
        margin: auto 4px auto 0.5rem;
        border-radius: 4px;
        height: 1.8rem;
        width: 10rem;
        font-weight: 300;
        font-size: 1rem;
    }
    .navbar-list {
        display: flex;
        margin: auto 8px auto auto;
        padding-left: 8px;
    }
    .navbar-list li {
        list-style-type: none;
        position: relative;
    }
    .navbar-list li:before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #424245;
    }
    .navbar-list a {
        color: #fff;
        text-decoration: none;
        display: flex;
        align-items: center;
        padding: 16px 8px 16px 8px;
        font-size: 1.1rem;
        font-weight: 300;
    }

    @media only screen and (min-width: 767px) {
        /* h1 {
            display: none;
        } */
        /* .mobile-icon {
            display: none;
        } */
        /* .navbar-list {
            display: flex;
            padding: 0;
        }
        .navbar-list a {
            display: inline-flex;
        } */
    }
</style>
